import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

import { I18nService } from '../../../services/i18n/i18n.service';

interface LanguageOption {
  language: string;
  code: string;
  type: string;
  label: string;
}

@Component({
  selector: 'app-lang-selector',
  imports: [
    MatMenuModule,
    MatButtonModule
  ],
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LangSelectorComponent {
  private i18nService = inject(I18nService);

  public currentLang = this.i18nService.getCurrentLanguageSignal();
  public selectedLangLabel = computed(() => this.languages.find(lang =>
    lang.code === this.currentLang())?.label);
  public isMenuOpen = false;

  public languages: LanguageOption[] = [
    {
      language: 'English',
      code: 'en',
      type: 'CA',
      label: 'EN',
    },
    {
      language: 'Français',
      code: 'fr',
      type: 'CA',
      label: 'FR',
    },
    {
      language: 'Español',
      code: 'es',
      type: 'CA',
      label: 'ES',
    },
  ];

  public changeLanguage(lang: LanguageOption): void {
    this.i18nService.changeLanguage(lang.code);
  }

  public onMenuOpened() {
    this.isMenuOpen = true;
  }

  public onMenuClosed() {
    this.isMenuOpen = false;
  }
}
